<template>
  <f7-page class="page-customer-create">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>SỬA THÔNG TIN KH</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:ellipsis_vertical" popover-open=".popover-menu"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>THÔNG TIN KHÁCH HÀNG</f7-block-title>
    <f7-list inset inline-labels class="mb-0">
      <f7-list-input
          label="Họ tên"
          type="text"
          :value="form_edit.fullname"
          @input="form_edit.fullname = $event.target.value"
          placeholder="Nguyễn A">
      </f7-list-input>
      <f7-list-input
          label="Số ĐT"
          type="text"
          :value="form_edit.mobile"
          @input="form_edit.mobile = $event.target.value"
          placeholder="Số điện thoại">
      </f7-list-input>
    </f7-list>
    <f7-row no-gap>
      <f7-col>
        <f7-list inset class="mt-1">
          <f7-list-item radio-icon="start" radio :value="1" name="cust-type" title="Khách" :checked="form_edit.type === 1" @change="form_edit.type = $event.target.value"
          ></f7-list-item>
        </f7-list>
      </f7-col>
      <f7-col>
        <f7-list inset class="mt-1">
          <f7-list-item radio-icon="start" radio :value="2" name="cust-type" title="Chủ" :checked="form_edit.type === 2" @change="form_edit.type = $event.target.value"
          ></f7-list-item>
        </f7-list>
      </f7-col>
    </f7-row>
    <template v-if="user_info.server_region === 'hanoi'">
      <f7-block inset strong class="mt-0 mb-2">
        <p class="lead">Đơn vị tính xiên</p>
        <p>
          <label class="mr-2">
            <f7-radio @change="form_edit.config_deal['mb_hanoi'].exchange_point = 1" :checked="form_edit.config_deal['mb_hanoi'].exchange_point === 1"></f7-radio>
            Nhân 10 khi là điểm : 10 ngàn = 1 điểm
          </label>
        </p>
        <p>
          <label class="mr-2">
            <f7-radio @change="form_edit.config_deal['mb_hanoi'].exchange_point = 2" :checked="form_edit.config_deal['mb_hanoi'].exchange_point === 2"></f7-radio>
            Giữ nguyên giá : 1 ngàn = 1 điểm
          </label>
        </p>
      </f7-block>
      <f7-block class="mt-0 mb-0">
        <f7-row no-gap>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Cò"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Lô"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].rate_bao"
                @input="form_edit.config_deal.mb_hanoi['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đề"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].rate_dd"
                @input="form_edit.config_deal.mb_hanoi['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Ba càng"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['3c'].rate_dd"
                @input="form_edit.config_deal.mb_hanoi['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đầu nhất"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].rate_daunhat"
                @input="form_edit.config_deal.mb_hanoi['2c'].rate_daunhat = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Trúng"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Lô"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].win_bao"
                @input="form_edit.config_deal.mb_hanoi['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đề"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].win_dd"
                @input="form_edit.config_deal.mb_hanoi['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Ba càng"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['3c'].win_dd"
                @input="form_edit.config_deal.mb_hanoi['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Đầu nhất"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].win_daunhat"
                @input="form_edit.config_deal.mb_hanoi['2c'].win_daunhat = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block class="mt-0 mb-0">
        <f7-row no-gap>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Cò"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Xiên 2"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].rate_dx_2"
                @input="form_edit.config_deal.mb_hanoi['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 3"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].rate_dx_3"
                @input="form_edit.config_deal.mb_hanoi['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 4"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].rate_dx_4"
                @input="form_edit.config_deal.mb_hanoi['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-item title="Trúng"></f7-list-item>
              <f7-list-input
                outline
                floating-label
                label="Xiên 2"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].win_dx_2"
                @input="form_edit.config_deal.mb_hanoi['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 3"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].win_dx_3"
                @input="form_edit.config_deal.mb_hanoi['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
              <f7-list-input
                outline
                floating-label
                label="Xiên 4"
                type="text"
                :value="form_edit.config_deal.mb_hanoi['2c'].win_dx_4"
                @input="form_edit.config_deal.mb_hanoi['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-block>
      <f7-block class="mt-0">
        <f7-row no-gap>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-input
                outline
                floating-label
                label="Phần trăm tổng"
                type="number"
                :value="form_edit.config_deal.mb_hanoi.total_percent"
                @input="form_edit.config_deal.mb_hanoi.total_percent = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list class="mt-0 mb-2">
              <f7-list-input
                outline
                floating-label
                label="Phần trăm hồi"
                type="number"
                :value="form_edit.config_deal.mb_hanoi.line_percent"
                @input="form_edit.config_deal.mb_hanoi.line_percent = !!$event.target.value ? $event.target.value : 0">
              </f7-list-input>
            </f7-list>
          </f7-col>
        </f7-row>
      </f7-block>
    </template>
    <template v-else>
      <f7-block inset strong class="mt-0 mb-2" v-if="user_info.user_configs.display_mb || user_info.user_configs.display_mn || user_info.user_configs.display_mt || user_info.user_configs.display_mn_mtay || user_info.user_configs.display_mt_mtay || user_info.user_configs.display_mt_buonme || user_info.user_configs.display_mb_buonme || user_info.user_configs.display_mn_buonme">
        <p class="lead">Loại cò</p>
        <p v-if="region_selected === 'mn_buonme' || region_selected === 'mb_buonme' || region_selected === 'mt_buonme'">
          <label class="mr-2">
            <f7-radio :value="false" @change="form_edit.config_deal.mn_buonme.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mb_buonme.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mt_buonme.calc_number_lo = ($event.target.value === 'true')" :checked="form_edit.config_deal.mn_buonme.calc_number_lo === false"></f7-radio>
            Tỉ lệ
          </label>
          <label class="mr-2">
            <f7-radio :value="true" @change="form_edit.config_deal.mn_buonme.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mb_buonme.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mt_buonme.calc_number_lo = ($event.target.value === 'true')" :checked="form_edit.config_deal.mn_buonme.calc_number_lo === true"></f7-radio>
            Thành tiền
          </label>
        </p>
        <p v-else>
          <label class="mr-2">
            <f7-radio :value="false" @change="form_edit.config_deal.mn.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mb.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mt.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mb_ngan.calc_number_lo = ($event.target.value === 'true')" :checked="form_edit.config_deal.mn.calc_number_lo === false"></f7-radio>
            Tỉ lệ
          </label>
          <label class="mr-2">
            <f7-radio :value="true" @change="form_edit.config_deal.mn.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mb.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mt.calc_number_lo = ($event.target.value === 'true'), form_edit.config_deal.mb_ngan.calc_number_lo = ($event.target.value === 'true')" :checked="form_edit.config_deal.mn.calc_number_lo === true"></f7-radio>
            Thành tiền
          </label>
        </p>
        <template v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay">
          <p class="lead">Xiên 2-3-4 Miền Bắc</p>
          <p>
            <label class="mr-2">
              <f7-radio @change="form_edit.config_deal.mb.dx_style = 2, form_edit.config_deal.mb_ngan.dx_style = 2" :checked="form_edit.config_deal.mb.dx_style === 2"></f7-radio>
              Cho phép
            </label>
            <label class="mr-2">
              <f7-radio @change="form_edit.config_deal.mb.dx_style = 1, form_edit.config_deal.mb_ngan.dx_style = 1" :checked="form_edit.config_deal.mb.dx_style === 1"></f7-radio>
              Không
            </label>
          </p>
        </template>
        <template v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay || !!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay || !!user_info.user_configs.display_mt_buonme || !!user_info.user_configs.display_mn_buonme || !!user_info.user_configs.display_mb_buonme">
          <p class="lead">Tính Ủi</p>
          <p>
            <label class="mr-2">
              <f7-radio @change="form_edit.config_deal.mn.ui_mode = 1, form_edit.config_deal.mt.ui_mode = 1" :checked="form_edit.config_deal.mn.ui_mode === 1"></f7-radio>
              Cho phép
            </label>
            <label class="mr-2">
              <f7-radio @change="form_edit.config_deal.mn.ui_mode = 0, form_edit.config_deal.mt.ui_mode = 0" :checked="form_edit.config_deal.mn.ui_mode === 0"></f7-radio>
              Không
            </label>
          </p>
        </template>
      </f7-block>
      <f7-block class="mb-1">
        <f7-segmented raised strong>
          <template v-if="!!user_info.user_configs.display_mn_buonme || !!user_info.user_configs.display_mb_buonme || !!user_info.user_configs.display_mt_buonme">
            <f7-button v-if="!!user_info.user_configs.display_mn_buonme" :active="region_selected === 'mn_buonme'" @click="region_selected = 'mn_buonme'">
              M.NAM
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mb_buonme" :active="region_selected === 'mb_buonme'" @click="region_selected = 'mb_buonme'">
              M.BẮC
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mt_buonme" :active="region_selected === 'mt_buonme'" @click="region_selected = 'mt_buonme'">
              M.TRUNG
            </f7-button>
          </template>
          <template v-else>
            <f7-button v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay" :active="region_selected === 'mn'" @click="region_selected = 'mn'">
              M.NAM
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay" :active="region_selected === 'mb'" @click="region_selected = 'mb'">
              M.BẮC
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay" :active="region_selected === 'mt'" @click="region_selected = 'mt'">
              M.TRUNG
            </f7-button>
            <f7-button v-if="!!user_info.user_configs.display_mb_ngan" :active="region_selected === 'mb_ngan'" @click="region_selected = 'mb_ngan'">
              NGHỆ AN
            </f7-button>
          </template>
        </f7-segmented>
      </f7-block>
      <template v-if="region_selected === 'mn'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].rate_bao"
                  @input="form_edit.config_deal.mn['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].rate_dd"
                  @input="form_edit.config_deal.mn['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_edit.config_deal.mn.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  disabled
                  value=""
                >
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].rate_baylo"
                  @input="form_edit.config_deal.mn['2c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].rate_da"
                  @input="form_edit.config_deal.mn['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].rate_dx"
                  @input="form_edit.config_deal.mn['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mn['3c'].rate_bao"
                  @input="form_edit.config_deal.mn['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mn['3c'].rate_baylo"
                  @input="form_edit.config_deal.mn['3c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mn['3c'].rate_dd"
                  @input="form_edit.config_deal.mn['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mn['4c'].rate_bao"
                  @input="form_edit.config_deal.mn['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mn['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mn['4c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].win_bao"
                  @input="form_edit.config_deal.mn['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].win_dd"
                  @input="form_edit.config_deal.mn['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_edit.config_deal.mn.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].win_ui"
                  @input="form_edit.config_deal.mn['2c'].win_ui = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].win_baylo"
                  @input="form_edit.config_deal.mn['2c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_edit.config_deal.mn['2c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].win_da"
                  @input="form_edit.config_deal.mn['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_edit.config_deal.mn['2c'].win_dx"
                  @input="form_edit.config_deal.mn['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mn['3c'].win_bao"
                  @input="form_edit.config_deal.mn['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mn['3c'].win_baylo"
                  @input="form_edit.config_deal.mn['3c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_edit.config_deal.mn['3c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mn['3c'].win_dd"
                  @input="form_edit.config_deal.mn['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mn['4c'].win_bao"
                  @input="form_edit.config_deal.mn['4c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type" :value="1" @change="form_edit.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type" :value="2" @change="form_edit.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type" :value="3" @change="form_edit.config_deal.mn.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type_dx" :value="1" @change="form_edit.config_deal.mn.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type_dx" :value="2" @change="form_edit.config_deal.mn.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio name="mn_rate_bonus_type_dx" :value="3" @change="form_edit.config_deal.mn.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mn.total_percent"
                  @input="form_edit.config_deal.mn.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mn.line_percent"
                  @input="form_edit.config_deal.mn.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mb'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_bao"
                  @input="form_edit.config_deal.mb['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_dd"
                  @input="form_edit.config_deal.mb['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 8lô"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_tamlo"
                  @input="form_edit.config_deal.mb['2c'].rate_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_da"
                  @input="form_edit.config_deal.mb['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mb['3c'].rate_bao"
                  @input="form_edit.config_deal.mb['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mb['3c'].rate_baylo"
                  @input="form_edit.config_deal.mb['3c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mb['3c'].rate_dd"
                  @input="form_edit.config_deal.mb['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mb['4c'].rate_bao"
                  @input="form_edit.config_deal.mb['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mb['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mb['4c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_bao"
                  @input="form_edit.config_deal.mb['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_dd"
                  @input="form_edit.config_deal.mb['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 8lô"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_baylo"
                  @input="form_edit.config_deal.mb['2c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_edit.config_deal.mb['2c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_da"
                  @input="form_edit.config_deal.mb['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mb['3c'].win_bao"
                  @input="form_edit.config_deal.mb['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mb['3c'].win_baylo"
                  @input="form_edit.config_deal.mb['3c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_edit.config_deal.mb['3c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mb['3c'].win_dd"
                  @input="form_edit.config_deal.mb['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mb['4c'].win_bao"
                  @input="form_edit.config_deal.mb['4c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block class="mt-0 mb-0" v-if="form_edit.config_deal.mb.dx_style === 2">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 2"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_dx_2"
                  @input="form_edit.config_deal.mb['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 3"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_dx_3"
                  @input="form_edit.config_deal.mb['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 4"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].rate_dx_4"
                  @input="form_edit.config_deal.mb['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 2"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_dx_2"
                  @input="form_edit.config_deal.mb['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 3"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_dx_3"
                  @input="form_edit.config_deal.mb['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX 4"
                  type="text"
                  :value="form_edit.config_deal.mb['2c'].win_dx_4"
                  @input="form_edit.config_deal.mb['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mb.rate_bonus_type = !!$event.target.value ? 1 : 0" :checked="form_edit.config_deal.mb.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mb.rate_bonus_type = !!$event.target.value ? 2 : 0" :checked="form_edit.config_deal.mb.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mb.rate_bonus_type = !!$event.target.value ? 3 : 0" :checked="form_edit.config_deal.mb.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mb.total_percent"
                  @input="form_edit.config_deal.mb.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mb.line_percent"
                  @input="form_edit.config_deal.mb.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mt'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].rate_bao"
                  @input="form_edit.config_deal.mt['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].rate_dd"
                  @input="form_edit.config_deal.mt['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_edit.config_deal.mt.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  disabled
                  value=""
                >
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].rate_baylo"
                  @input="form_edit.config_deal.mt['2c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].rate_da"
                  @input="form_edit.config_deal.mt['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].rate_dx"
                  @input="form_edit.config_deal.mt['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mt['3c'].rate_bao"
                  @input="form_edit.config_deal.mt['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mt['3c'].rate_baylo"
                  @input="form_edit.config_deal.mt['3c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mt['3c'].rate_dd"
                  @input="form_edit.config_deal.mt['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mt['4c'].rate_bao"
                  @input="form_edit.config_deal.mt['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mt['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mt['4c'].rate_baylo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].win_bao"
                  @input="form_edit.config_deal.mt['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].win_dd"
                  @input="form_edit.config_deal.mt['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  v-if="form_edit.config_deal.mt.ui_mode === 1"
                  outline
                  floating-label
                  label="Ủi"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].win_ui"
                  @input="form_edit.config_deal.mt['2c'].win_ui = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].win_baylo"
                  @input="form_edit.config_deal.mt['2c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_edit.config_deal.mt['2c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].win_da"
                  @input="form_edit.config_deal.mt['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C DX"
                  type="text"
                  :value="form_edit.config_deal.mt['2c'].win_dx"
                  @input="form_edit.config_deal.mt['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mt['3c'].win_bao"
                  @input="form_edit.config_deal.mt['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C 7lô"
                  type="text"
                  :value="form_edit.config_deal.mt['3c'].win_baylo"
                  @input="form_edit.config_deal.mt['3c'].win_baylo = !!$event.target.value ? $event.target.value : 0, form_edit.config_deal.mt['3c'].win_tamlo = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C ĐĐ"
                  type="text"
                  :value="form_edit.config_deal.mt['3c'].win_dd"
                  @input="form_edit.config_deal.mt['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mt['4c'].win_bao"
                  @input="form_edit.config_deal.mt['4c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mt.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mt.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mt.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mt.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mt.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mt.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mt.total_percent"
                  @input="form_edit.config_deal.mt.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mt.line_percent"
                  @input="form_edit.config_deal.mt.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mb_ngan'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].rate_bao"
                  @input="form_edit.config_deal.mb_ngan['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Đề"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].rate_dd"
                  @input="form_edit.config_deal.mb_ngan['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Ba càng"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['3c'].rate_dd"
                  @input="form_edit.config_deal.mb_ngan['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Lô"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].win_bao"
                  @input="form_edit.config_deal.mb_ngan['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Đề"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].win_dd"
                  @input="form_edit.config_deal.mb_ngan['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Ba càng"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['3c'].win_dd"
                  @input="form_edit.config_deal.mb_ngan['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 2"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].rate_dx_2"
                  @input="form_edit.config_deal.mb_ngan['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 3"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].rate_dx_3"
                  @input="form_edit.config_deal.mb_ngan['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 4"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].rate_dx_4"
                  @input="form_edit.config_deal.mb_ngan['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 2"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].win_dx_2"
                  @input="form_edit.config_deal.mb_ngan['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 3"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].win_dx_3"
                  @input="form_edit.config_deal.mb_ngan['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="Xiên 4"
                  type="text"
                  :value="form_edit.config_deal.mb_ngan['2c'].win_dx_4"
                  @input="form_edit.config_deal.mb_ngan['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mb_ngan.total_percent"
                  @input="form_edit.config_deal.mb_ngan.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mb_ngan.line_percent"
                  @input="form_edit.config_deal.mb_ngan.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mn_buonme'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].rate_bao"
                  @input="form_edit.config_deal.mn_buonme['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].rate_dd"
                  @input="form_edit.config_deal.mn_buonme['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT (1 đài)"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].rate_da"
                  @input="form_edit.config_deal.mn_buonme['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX (2,3 đài)"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].rate_dx"
                  @input="form_edit.config_deal.mn_buonme['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['3c'].rate_bao"
                  @input="form_edit.config_deal.mn_buonme['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['3c'].rate_dd"
                  @input="form_edit.config_deal.mn_buonme['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['4c'].rate_bao"
                  @input="form_edit.config_deal.mn_buonme['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mn_buonme['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].win_bao"
                  @input="form_edit.config_deal.mn_buonme['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].win_dd"
                  @input="form_edit.config_deal.mn_buonme['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].win_da"
                  @input="form_edit.config_deal.mn_buonme['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['2c'].win_dx"
                  @input="form_edit.config_deal.mn_buonme['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['3c'].win_bao"
                  @input="form_edit.config_deal.mn_buonme['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['3c'].win_dd"
                  @input="form_edit.config_deal.mn_buonme['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mn_buonme['4c'].win_bao"
                  @input="form_edit.config_deal.mn_buonme['4c'].win_bao = !!$event.target.value ? $event.target.value : 0;
                                        form_edit.config_deal.mn_buonme['4c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mn_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn_buonme.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mn_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn_buonme.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mn_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn_buonme.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mn_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn_buonme.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mn_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn_buonme.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mn_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mn_buonme.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mn_buonme.total_percent"
                  @input="form_edit.config_deal.mn_buonme.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mn_buonme.line_percent"
                  @input="form_edit.config_deal.mn_buonme.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mt_buonme'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].rate_bao"
                  @input="form_edit.config_deal.mt_buonme['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].rate_dd"
                  @input="form_edit.config_deal.mt_buonme['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT (1 đài)"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].rate_da"
                  @input="form_edit.config_deal.mt_buonme['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX (2,3 đài)"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].rate_dx"
                  @input="form_edit.config_deal.mt_buonme['2c'].rate_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['3c'].rate_bao"
                  @input="form_edit.config_deal.mt_buonme['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['3c'].rate_dd"
                  @input="form_edit.config_deal.mt_buonme['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['4c'].rate_bao"
                  @input="form_edit.config_deal.mt_buonme['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mt_buonme['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].win_bao"
                  @input="form_edit.config_deal.mt_buonme['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].win_dd"
                  @input="form_edit.config_deal.mt_buonme['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáT"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].win_da"
                  @input="form_edit.config_deal.mt_buonme['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C ĐáX"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['2c'].win_dx"
                  @input="form_edit.config_deal.mt_buonme['2c'].win_dx = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['3c'].win_bao"
                  @input="form_edit.config_deal.mt_buonme['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['3c'].win_dd"
                  @input="form_edit.config_deal.mt_buonme['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mt_buonme['4c'].win_bao"
                  @input="form_edit.config_deal.mt_buonme['4c'].win_bao = !!$event.target.value ? $event.target.value : 0;
                                        form_edit.config_deal.mt_buonme['4c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mt_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt_buonme.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mt_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt_buonme.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mt_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt_buonme.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
          <p class="lead">Tính trúng Đá xiên</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mt_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt_buonme.rate_bonus_type_dx === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mt_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt_buonme.rate_bonus_type_dx === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mt_buonme.rate_bonus_type_dx = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mt_buonme.rate_bonus_type_dx === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mt_buonme.total_percent"
                  @input="form_edit.config_deal.mt_buonme.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mt_buonme.line_percent"
                  @input="form_edit.config_deal.mt_buonme.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
      <template v-if="region_selected === 'mb_buonme'">
        <f7-block class="mt-0 mb-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Cò"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].rate_bao"
                  @input="form_edit.config_deal.mb_buonme['2c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].rate_dd"
                  @input="form_edit.config_deal.mb_buonme['2c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].rate_da"
                  @input="form_edit.config_deal.mb_buonme['2c'].rate_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Hai"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].rate_dx_2"
                  @input="form_edit.config_deal.mb_buonme['2c'].rate_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Ba"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].rate_dx_3"
                  @input="form_edit.config_deal.mb_buonme['2c'].rate_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Bốn"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].rate_dx_4"
                  @input="form_edit.config_deal.mb_buonme['2c'].rate_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['3c'].rate_bao"
                  @input="form_edit.config_deal.mb_buonme['3c'].rate_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['3c'].rate_dd"
                  @input="form_edit.config_deal.mb_buonme['3c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['4c'].rate_bao"
                  @input="form_edit.config_deal.mb_buonme['4c'].rate_bao = !!$event.target.value ? $event.target.value : 0;
                                form_edit.config_deal.mb_buonme['4c'].rate_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-item title="Trúng"></f7-list-item>
                <f7-list-input
                  outline
                  floating-label
                  label="2C lô"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].win_bao"
                  @input="form_edit.config_deal.mb_buonme['2c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C dkc"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].win_dd"
                  @input="form_edit.config_deal.mb_buonme['2c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].win_da"
                  @input="form_edit.config_deal.mb_buonme['2c'].win_da = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Hai"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].win_dx_2"
                  @input="form_edit.config_deal.mb_buonme['2c'].win_dx_2 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Ba"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].win_dx_3"
                  @input="form_edit.config_deal.mb_buonme['2c'].win_dx_3 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="2C Đá Bốn"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['2c'].win_dx_4"
                  @input="form_edit.config_deal.mb_buonme['2c'].win_dx_4 = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C lô"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['3c'].win_bao"
                  @input="form_edit.config_deal.mb_buonme['3c'].win_bao = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="3C kdb"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['3c'].win_dd"
                  @input="form_edit.config_deal.mb_buonme['3c'].win_dd = !!$event.target.value ? $event.target.value : 0; ">
                </f7-list-input>
                <f7-list-input
                  outline
                  floating-label
                  label="4C"
                  type="text"
                  :value="form_edit.config_deal.mb_buonme['4c'].win_bao"
                  @input="form_edit.config_deal.mb_buonme['4c'].win_bao = !!$event.target.value ? $event.target.value : 0;
                                        form_edit.config_deal.mb_buonme['4c'].win_dd = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-block inset strong class="mt-0 mb-2">
          <p class="lead">Tính trúng Đá thẳng</p>
          <p>
            <label class="mr-2">
              <f7-radio :value="1" @change="form_edit.config_deal.mb_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mb_buonme.rate_bonus_type === 1"></f7-radio>
              1 lần
            </label>
            <label class="mr-2">
              <f7-radio :value="2" @change="form_edit.config_deal.mb_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mb_buonme.rate_bonus_type === 2"></f7-radio>
              ky rưỡi
            </label>
            <label class="mr-2">
              <f7-radio :value="3" @change="form_edit.config_deal.mb_buonme.rate_bonus_type = !!$event.target.value ? $event.target.value : 0" :checked="form_edit.config_deal.mb_buonme.rate_bonus_type === 3"></f7-radio>
              nhiều cặp
            </label>
          </p>
        </f7-block>
        <f7-block class="mt-0">
          <f7-row no-gap>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm tổng"
                  type="number"
                  :value="form_edit.config_deal.mb_buonme.total_percent"
                  @input="form_edit.config_deal.mb_buonme.total_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="mt-0 mb-2">
                <f7-list-input
                  outline
                  floating-label
                  label="Phần trăm hồi"
                  type="number"
                  :value="form_edit.config_deal.mb_buonme.line_percent"
                  @input="form_edit.config_deal.mb_buonme.line_percent = !!$event.target.value ? $event.target.value : 0">
                </f7-list-input>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </template>
    </template>
    <f7-block inset>
      <f7-button class="button-medium" fill raised color="primary" @click.prevent="saveCustomer">LƯU THÔNG TIN
      </f7-button>
    </f7-block>
    <f7-popover class="popover-menu">
      <f7-list>
        <f7-list-item link popover-close @click.prevent="copyCustomer" title="Copy">
          <f7-icon slot="media" ios="f7:doc_on_doc"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close @click.prevent="removeCustomer" title="Xóa">
          <f7-icon slot="media" ios="f7:trash"></f7-icon>
        </f7-list-item>
      </f7-list>
    </f7-popover>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed:{
    ...mapState(['user_info'])
  },
  props     :{
    custId  :String,
    customer:Object
  },
  data(){
    return {
      form_edit      :{
        type       :1,
        fullname   :'',
        mobile     :'',
        config_deal:{
          mn:{
            rate_bonus_type   :2,
            rate_bonus_type_dx:3,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :0,
              rate_da         :0.75,
              rate_dx         :0.75,
              rate_dx_2       :0.75,
              rate_dx_3       :0.75,
              rate_dx_4       :0.75,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :750,
              win_dx          :550,
              win_dx_2        :550,
              win_dx_3        :550,
              win_dx_4        :550,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            }
          },
          mb:{
            rate_bonus_type   :3,
            rate_bonus_type_dx:1,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :0,
              rate_da         :0.75,
              rate_dx         :0,
              rate_dx_2       :0.75,
              rate_dx_3       :0.75,
              rate_dx_4       :0.75,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :650,
              win_dx          :0,
              win_dx_2        :550,
              win_dx_3        :550,
              win_dx_4        :550,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            }
          },
          mt:{
            rate_bonus_type   :2,
            rate_bonus_type_dx:3,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :0,
              rate_da         :0.75,
              rate_dx         :0.75,
              rate_dx_2       :0.75,
              rate_dx_3       :0.75,
              rate_dx_4       :0.75,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :750,
              win_dx          :550,
              win_dx_2        :550,
              win_dx_3        :550,
              win_dx_4        :550,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            }
          },
          mb_ngan:{
            rate_bonus_type   :3,
            rate_bonus_type_dx:1,
            total_percent     :100,
            line_percent      :0,
            total_percent_type:1,
            dx_style          :1,
            ui_mode           :0,
            '2c'              :{
              rate_bao        :0.75,
              rate_dd         :0.75,
              rate_baylo      :0.75,
              rate_tamlo      :0.75,
              rate_ui         :0,
              rate_da         :0.75,
              rate_dx         :0,
              rate_dx_2       :0.75,
              rate_dx_3       :0.75,
              rate_dx_4       :0.75,
              win_bao         :75,
              win_dd          :75,
              win_baylo       :75,
              win_tamlo       :75,
              win_ui          :0,
              win_da          :650,
              win_dx          :0,
              win_dx_2        :550,
              win_dx_3        :550,
              win_dx_4        :550,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '3c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :650,
              win_dd          :650,
              win_baylo       :650,
              win_tamlo       :650,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            },
            '4c'              :{
              rate_bao        :0.65,
              rate_dd         :0.65,
              rate_baylo      :0.65,
              rate_tamlo      :0.65,
              rate_ui         :0,
              rate_da         :0,
              rate_dx         :0,
              win_bao         :5500,
              win_dd          :5500,
              win_baylo       :5500,
              win_tamlo       :5500,
              win_ui          :0,
              win_da          :0,
              win_dx          :0,
              over_point_bao  :0,
              over_point_dd   :0,
              over_point_baylo:0,
              over_point_tamlo:0,
              over_point_da   :0,
              over_point_dx   :0
            }
          },
          mb_hanoi: {
            rate_bonus_type: 3,
            rate_bonus_type_dx: 1,
            total_percent: 100,
            line_percent: 0,
            total_percent_type: 1,
            dx_style: 1,
            ui_mode: 0,
            exchange_point: 1,
            '2c': {
              rate_bao: 21.7,
              rate_dd: 0.725,
              rate_daunhat: 0.725,
              rate_baylo: 0,
              rate_tamlo: 0,
              rate_ui: '',
              rate_da: 0.6,
              rate_dx: 0.6,
              rate_dx_2: 0.6,
              rate_dx_3: 0.6,
              rate_dx_4: 0.6,
              win_bao: 80,
              win_dd: 70,
              win_daunhat: 70,
              win_baylo: 0,
              win_tamlo: 0,
              win_ui: 0,
              win_da: 100,
              win_dx: 100,
              win_dx_2: 100,
              win_dx_3: 400,
              win_dx_4: 1000,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '3c': {
              rate_bao: 0,
              rate_dd: 0.9,
              rate_baylo: 0,
              rate_tamlo: 0,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 0,
              win_dd: 400,
              win_baylo: 0,
              win_tamlo: 0,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '4c': {
              rate_bao: 0,
              rate_dd: 0,
              rate_baylo: 0,
              rate_tamlo: 0,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 0,
              win_dd: 0,
              win_baylo: 0,
              win_tamlo: 0,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            calc_number_lo: false
          },
          mn_buonme: {
            rate_bonus_type: 2,
            rate_bonus_type_dx: 3,
            total_percent: 100,
            line_percent: 0,
            total_percent_type: 1,
            dx_style: 1,
            ui_mode: 0,
            '2c': {
              rate_bao: 0.75,
              rate_dd: 0.75,
              rate_baylo: 0.75,
              rate_tamlo: 0.75,
              rate_ui: '',
              rate_da: 0.75,
              rate_dx: 0.75,
              rate_dx_2: 0.75,
              rate_dx_3: 0.75,
              rate_dx_4: 0.75,
              win_bao: 75,
              win_dd: 75,
              win_baylo: 75,
              win_tamlo: 75,
              win_ui: 0,
              win_da: 700,
              win_dx: 550,
              win_dx_2: 550,
              win_dx_3: 550,
              win_dx_4: 550,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '3c': {
              rate_bao: 0.65,
              rate_dd: 0.65,
              rate_baylo: 0.65,
              rate_tamlo: 0.65,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 650,
              win_dd: 650,
              win_baylo: 650,
              win_tamlo: 650,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '4c': {
              rate_bao: 0.65,
              rate_dd: 0.65,
              rate_baylo: 0.65,
              rate_tamlo: 0.65,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 5500,
              win_dd: 5500,
              win_baylo: 5500,
              win_tamlo: 5500,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            calc_number_lo: false
          },
          mb_buonme: {
            rate_bonus_type: 3,
            rate_bonus_type_dx: 1,
            total_percent: 100,
            line_percent: 0,
            total_percent_type: 1,
            dx_style: 1,
            ui_mode: 0,
            '2c': {
              rate_bao: 0.75,
              rate_dd: 0.75,
              rate_baylo: 0.75,
              rate_tamlo: 0.75,
              rate_ui: '',
              rate_da: 0.75,
              rate_dx: 0.75,
              rate_dx_2: 0.75,
              rate_dx_3: 0.75,
              rate_dx_4: 0.75,
              win_bao: 75,
              win_dd: 75,
              win_baylo: 75,
              win_tamlo: 75,
              win_ui: 0,
              win_da: 650,
              win_dx: 650,
              win_dx_2: 1000,
              win_dx_3: 4000,
              win_dx_4: 10000,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '3c': {
              rate_bao: 0.65,
              rate_dd: 0.65,
              rate_baylo: 0.65,
              rate_tamlo: 0.65,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 650,
              win_dd: 650,
              win_baylo: 650,
              win_tamlo: 650,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '4c': {
              rate_bao: 0.65,
              rate_dd: 0.65,
              rate_baylo: 0.65,
              rate_tamlo: 0.65,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 5500,
              win_dd: 5500,
              win_baylo: 5500,
              win_tamlo: 5500,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            calc_number_lo: false
          },
          mt_buonme: {
            rate_bonus_type: 2,
            rate_bonus_type_dx: 3,
            total_percent: 100,
            line_percent: 0,
            total_percent_type: 1,
            dx_style: 1,
            ui_mode: 0,
            '2c': {
              rate_bao: 0.75,
              rate_dd: 0.75,
              rate_baylo: 0.75,
              rate_tamlo: 0.75,
              rate_ui: '',
              rate_da: 0.75,
              rate_dx: 0.75,
              rate_dx_2: 0.75,
              rate_dx_3: 0.75,
              rate_dx_4: 0.75,
              win_bao: 75,
              win_dd: 75,
              win_baylo: 75,
              win_tamlo: 75,
              win_ui: 0,
              win_da: 700,
              win_dx: 550,
              win_dx_2: 550,
              win_dx_3: 550,
              win_dx_4: 550,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '3c': {
              rate_bao: 0.65,
              rate_dd: 0.65,
              rate_baylo: 0.65,
              rate_tamlo: 0.65,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 650,
              win_dd: 650,
              win_baylo: 650,
              win_tamlo: 650,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            '4c': {
              rate_bao: 0.65,
              rate_dd: 0.65,
              rate_baylo: 0.65,
              rate_tamlo: 0.65,
              rate_ui: '',
              rate_da: 0,
              rate_dx: 0,
              win_bao: 5500,
              win_dd: 5500,
              win_baylo: 5500,
              win_tamlo: 5500,
              win_ui: 0,
              win_da: 0,
              win_dx: 0,
              over_point_bao: 0,
              over_point_dd: 0,
              over_point_baylo: 0,
              over_point_tamlo: 0,
              over_point_da: 0,
              over_point_dx: 0
            },
            calc_number_lo: false
          },
        }
      },
      region_selected:'mn',
      calendar       :{},
      fresh_date     :''
    }
  },
  methods:{
    submitCustomerEdit(){
      let self = this;
      this.$f7.dialog.preloader();

      this.$store.dispatch('editCustomer', this.form_edit)
          .then(() => {
            return this.$store.dispatch('freshMessages', {
              customer_id:self.customer.id,
              date       :self.fresh_date
            });
          })
          .then(() => {
            return this.$store.dispatch('getCustomers', {
              page :1,
              limit:1000
            });
          })
          .then(() => {
            this.$f7.dialog.close();
            this.$f7.dialog.alert('Cập nhật thành công!', 'SUCCESS!');
          })
          .catch((err) => {
            this.$f7.dialog.close();
            this.$f7.dialog.alert(err, 'LỖI!');
          })
    },
    removeCustomer(){
      const self = this;
      this.$f7.dialog.confirm('Bạn có chắc chắn muốn xóa Khách hàng : ' + this.customer.fullname, 'THÔNG BÁO!', () => {
        self.$f7.dialog.preloader();
        self.$store.dispatch('removeCustomer', {
          id:this.customer.id
        }).then(() => {
          return self.$store.dispatch('getCustomers', {
            page :1,
            limit:1000
          });
        }).then(() => {
          self.$f7.dialog.close();
          this.$f7router.back();
        }).catch((err) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert(err, 'LỖI!');
        });
      });
    },
    copyCustomer(){
      this.$f7router.navigate(`/khach-hang/tao-moi`, {
        props:{
          customer_source:this.customer
        }
      });
    },
    saveCustomer(){
      this.calendar.open();
    }
  },
  mounted(){
    const self = this;
    this.form_edit = this.customer;

    self.calendar = self.$f7.calendar.create({
      closeOnSelect    :true,
      openIn           :'customModal',
      dateFormat       :'dd/mm/yyyy',
      locale           :'vi-VN',
      header           :true,
      headerPlaceholder:'Ngày áp dụng',
      on               :{
        dayClick:function(calendar, dayEl, year, month, day){
          self.fresh_date = self.$moment(new Date(year, month, day)).format('YYYY-MM-DD');
          self.submitCustomerEdit();
        }
      }
    });

    if (this.user_info.server_region === 'hanoi'){
      this.region_selected = 'mb_hanoi';
    } else {
      if (this.user_info.user_configs.display_mn || this.user_info.user_configs.display_mn_mtay) {
        this.region_selected = 'mn';
      }
      else if (this.user_info.user_configs.display_mt || this.user_info.user_configs.display_mt_mtay) {
        this.region_selected = 'mt';
      }
      else if (this.user_info.user_configs.display_mb || this.user_info.user_configs.display_mb_mtay) {
        this.region_selected = 'mb';
      }
      else if (this.user_info.user_configs.display_mb_ngan) {
        this.region_selected = 'mb_ngan';
      }
      else if (this.user_info.user_configs.display_mn_buonme) {
        this.region_selected = 'mn_buonme';
      }
      else if (this.user_info.user_configs.display_mt_buonme) {
        this.region_selected = 'mt_buonme';
      }
      else if (this.user_info.user_configs.display_mb_buonme) {
        this.region_selected = 'mb_buonme';
      }
    }
  }
};
</script>
<style>
.calendar-modal .toolbar a {
  color : #000000;
}
</style>
